import * as React from 'react';
import { Spin } from 'antd';
import styled from 'styled-components';

const Wrapper = styled.section<{ full?: boolean; height?: number }>`
    display: flex;
    width: 100%;
    height: ${p => (p.height ? p.height + 'px' : '100vh')};
    justify-content: center;
    align-items: center;

    ${p =>
        p.full &&
        `
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 15;
    background: white;  
    `};
`;

interface Props {
    className?: string;
    fullScreen?: boolean;
    height?: number;
}

const Loading = ({ className, fullScreen, height }: Props) => (
    <Wrapper className={className} full={fullScreen} height={height}>
        <Spin tip="Ladataan" />
    </Wrapper>
);

export default Loading;
